/**
* @NApiVersion 2.x
* @NModuleScope TargetAccount
* // Copyright (c) 2021, Oracle and/or its affiliates. All rights reserved.
* // Licensed under the Universal Permissive License v 1.0 as shown at http://oss.oracle.com/licenses/upl.
*/
define([
    'N/record',
    'N/runtime',
    'N/search'
], function (
    record,
    runtime,
    search
) {
    'use strict';

    var QAndAModel = {
        get: function (request) {
            try{

                var itemid = request.parameters.itemid 
                var searchResults = search.load({
                    id: 'customsearch_tt_questions_to_show',
                    type: 'customrecord_tt_question'
                })
                var mySearchFilter = search.createFilter({
                    name: 'custrecord_tt_product_id',
                    operator: search.Operator.IS,
                    values: itemid
                });
                searchResults.filters.push(mySearchFilter)
                var arrayResults = searchResults.run()

                //commented this code since in the front-end, the code is expecting an array
                //anywasy it was never executed, since the right access to counter should be: request.parameters.counter
                // if (request.counter) {
                //     return arrayResults.getRange({start: 0, end: 999}).length
                // }
                var questionsPerPage = parseInt(request.parameters.resultsPerPage)
                var page = parseInt(request.parameters.page) 
                var leftResult = page*questionsPerPage || 0;
                var rightResult = page*questionsPerPage + questionsPerPage || 999 ;
                var mappedResults = arrayResults.getRange({start: leftResult, end: rightResult}).map(function (result) {
                    return {
                        internalid: result.getValue('internalid'),
                        productId: result.getValue('custrecord_tt_product_id'),
                        question: result.getValue('custrecord_tt_question_text'),
                        answer: result.getValue('custrecord_tt_answer_text'),
                        isAnswered: result.getValue("custrecord_tt_is_answered"),
                        customerId: result.getValue("custrecord_tt_question_customer"),
                        customerName: result.getText("custrecord_tt_question_customer"),
                        displayName: result.getValue("custrecord_tt_customer_display_name"),
                        dateCreated: result.getValue("created"),
                        dateAnswered: result.getValue("custrecord_tt_date_of_answer"),
                        answeredBy: result.getText("custrecord_tt_answerer_employee"),
                        allResults: result
                    }
                });
                return mappedResults;
            }catch(e){
                log.error({title: 'ERROR_ON_QANDA_MODEL', details: JSON.stringify(e)});
                return [];
            }
        },

        post: function (request) {
            var body = JSON.parse(request.body);
            var questionText = body.question
            var displayName = body.displayname
            var customerId = body.customerid
            var productId = body.productid 
            var itemUrl = body.itemUrl 
            var question = record.create({
                type: 'customrecord_tt_question'
            });

            question.setValue({
                fieldId: 'custrecord_tt_question_text',
                value: questionText
            });

            question.setValue({
                fieldId: 'custrecord_tt_is_approved',
                value: false
            });

            question.setValue({
                fieldId: 'custrecord_tt_is_answered',
                value: false
            });

            question.setValue({
                fieldId: 'custrecord_tt_question_product',
                value: productId
            });

            question.setValue({
                fieldId: 'custrecord_tt_question_customer',
                value: customerId
            });

            question.setValue({
                fieldId: 'custrecord_tt_item_url',
                value: ""//itemUrl
            });

            question.setValue({
                fieldId: 'custrecord_tt_product_id',
                value: productId
            });

            question.setValue({
                fieldId: 'custrecord_tt_customer_display_name',
                value: displayName
            });

            return question.save()
        }
    }

    return QAndAModel
})
